import styles from './FormatHeroText.module.scss';

export const formatHeroText = (
  blackText?: string,
  redText?: string,
  redTextPlacement?: boolean,
  redTextNewLine?: boolean
) => {
  if (!redText) return blackText;

  return (
    <>
      {redTextPlacement ? (
        <>
          {blackText}
          {redTextNewLine && <br />}
          {!redTextNewLine ? (
            <>
              {' '}
              <span className={styles.redText}>{redText}</span>
            </>
          ) : (
            <span className={styles.redText}>{redText}</span>
          )}
        </>
      ) : (
        <>
          <span className={styles.redText}>{redText}</span>{' '}
          {redTextNewLine && <br />}
          {blackText}
        </>
      )}
    </>
  );
};
